var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vcarousel',{staticClass:"lg",attrs:{"data":_vm.list,"controls":!_vm.hideControls && this.images.length > 1,"indicators":!_vm.hideIndicators && this.images.length > 1,"indicator-type":"disc"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a24d1030","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/BigCarousel.vue
// module id = null
// module chunks = 